import { Radio, RadioGroup } from "@blueprintjs/core"
import {
  CurrencyInr,
  Percent,
  PlusCircle,
  SealPercent,
  Ticket,
  XCircle,
} from "@phosphor-icons/react"
import CustomButton from "components/Atoms/CustomButton"
import CustomDialog from "components/Atoms/CustomDialog"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { MY_COUPONS } from "graphql/coupons/index.gql"
import React, { useEffect, useState } from "react"

export type SelectDiscountType = {
  onComplete?: any
  sellableItemId?: any
  amount?: any
  dcId?: any
  isOrder?: boolean
  disabled?: boolean
  discount?: any
}

export const SelectDiscount = ({
  sellableItemId,
  amount,
  onComplete,
  dcId,
  isOrder,
  disabled = false,
  discount,
}: SelectDiscountType) => {
  const [isOpen, setOpen] = useState(false)
  const [discountType, setDiscountType] = useState()
  const [value, setValue] = useState()
  const [coupon, setCoupon] = useState<any>()

  const clearState = () => {
    setValue(null)
    setDiscountType(null)
    setCoupon(null)
  }

  const onClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (discount) {
      setValue(discount?.value)
      setDiscountType(discount?.discountType)
      setCoupon(discount?.coupon)
    }
  }, [discount])
  return (
    <>
      <CustomButton
        className="!h-fit"
        text={
          "Discount: " +
          (discountType === "coupon" && coupon
            ? coupon?.name
            : (discountType === "flat" || discountType === "percent") && value
            ? `${value} ${String(discountType).toUpperCase()}`
            : "")
        }
        rightIcon={
          coupon || value ? (
            <XCircle
              size={20}
              className="text-red"
              onClick={e => {
                e.stopPropagation()
                if (coupon || value) {
                  clearState()
                  onComplete?.(null)
                }
              }}
            />
          ) : (
            <PlusCircle size={20} className="text-green" />
          )
        }
        onClick={() => {
          setOpen(true)
        }}
        disabled={disabled}
      />
      <CustomDialog
        isOpen={isOpen}
        onClose={() => {
          onClose()
          clearState()
        }}
        title={
          <div className="flex gap-2 items-center">
            <SealPercent size={20} />
            <div>Discount Type</div>
          </div>
        }
        footerRightButton={
          <CustomButton
            text={"Ok"}
            onClick={() => {
              onComplete?.({
                discountType,
                value,
                coupon,
              })
              onClose()
            }}
          />
        }
      >
        <div>
          <RadioGroup
            className="flex items-start mt-4"
            onChange={(e: any) => {
              clearState()
              setDiscountType(e?.target.value)
            }}
            selectedValue={discountType}
            inline
          >
            <Radio
              value={"flat"}
              name="Flat"
              className="flex items-center gap-1"
            >
              <CurrencyInr size={18} />
              Flat Amount
            </Radio>
            <Radio value={"percent"} className="flex items-center gap-1">
              <Percent size={18} /> Percentage
            </Radio>
            <Radio value={"coupon"} className="flex items-center gap-1">
              <Ticket size={18} /> Coupon
            </Radio>
          </RadioGroup>
          {discountType === "flat" || discountType === "percent" ? (
            <StringInput
              value={value}
              onChange={(_, e) => {
                setValue(e)
              }}
              leftIcon={discountType === "flat" ? "rupee" : "percentage"}
            />
          ) : discountType === "coupon" ? (
            <DynamicSelector
              query={MY_COUPONS}
              variables={{
                sellableItemStockId: sellableItemId,
                totalAmount: amount || 0,
                dcId: dcId,
                isOrder: isOrder,
              }}
              value={coupon}
              onChange={(_, e) => {
                setCoupon(e)
              }}
              resetOnSelect={true}
            />
          ) : (
            <></>
          )}
        </div>
      </CustomDialog>
    </>
  )
}
